
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/refine-price",
      function () {
        return require("private-next-pages/refine-price/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/refine-price"])
      });
    }
  